import React, { useEffect, useRef } from "react";
import gsap from "gsap";

const Confetti: React.FC = () => {
  const confettiRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const colors = ["#FFD700", "#FF69B4", "#B0E0E6", "#98FB98"];
    const shapes = ["circle", "rect", "rect", "triangle"];

    const createParticle = () => {
      const particle = document.createElement("div");
      const size = Math.random() * 12 + 8;
      const shape = shapes[Math.floor(Math.random() * shapes.length)];

      gsap.set(particle, {
        attr: { class: `confetti ${shape}` },
        x: Math.random() * window.innerWidth,
        y: -size,
        width: size,
        height: size,
        backgroundColor: colors[Math.floor(Math.random() * colors.length)],
      });

      confettiRef.current?.appendChild(particle);

      gsap.to(particle, {
        y: window.innerHeight + size,
        rotation: Math.random() * 360,
        duration: Math.random() * 3 + 2,
        ease: "power1",
        onComplete: () => {
          particle.remove();
        },
      });
    };

    const interval = setInterval(createParticle, 100);

    return () => clearInterval(interval);
  }, []);

  return <div ref={confettiRef} className="confetti-container"></div>;
};

export default Confetti;
